module.exports = __webpack_public_path__ + "img/4_154.f7acbb53.png";